import * as React from 'react';
import { GridLineHeaderClassNames } from '../../surfaceItems/GridLineHeader';
import { GridLineHeaders } from '../../surfaceItems/GridLineHeaders';
import { ItemsLayout } from '../../interfaces/ItemsLayout';
import { SurfaceConstants, SurfaceStore, toPixelString } from 'owa-calendar-surface-core';
import { observer } from 'mobx-react';

const styles = require('./TimeStripBehavior.scss');

export default observer(function TimeStripBehavior({
    gridLineHeaderClassNames,
    headerWidth = SurfaceConstants.timeStripDefaultWidth,
    itemsLayout,
    surfaceStore,
    timeZones = [undefined],
}: {
    gridLineHeaderClassNames?: GridLineHeaderClassNames;
    headerWidth?: number;
    itemsLayout: ItemsLayout;
    surfaceStore: SurfaceStore;
    timeZones?: string[];
}) {
    const hoursInDay = 24;
    const heightPixelString = toPixelString(hoursInDay * SurfaceConstants.HourRowHeight);
    const widthPixelString = toPixelString(headerWidth);
    const headerStyle = { height: heightPixelString, width: widthPixelString };

    // TZ_BUG: We will not account for DST in the first column by not passing timeZoneId when index==0.
    // If we do that, and we have PST on the 1st and UTC on the 2nd then the GRID surface
    // ends up showing a 10amUTC event in the 4amPST slot, when it should in fact be at 3amPST.
    // That is likely a mismatch between the headers and the way items layout is
    // calculating the vertical position when DST gets in the picture.
    // In other words, the HEADERS will be showing [12am, 1am, 3am,...] while the surface thinks we are
    // showing [12am, 1am, 2am, 3am, ...].
    // If we don't do DST in the first column then the GRID and the 1st HEADER match as they should.
    // However, things look "wrong" in the daylight transition day (particularly when it starts) in other headers.
    // When showing PST 1st and UTC next, then a 10amUTC event ends up showing in the 3amPST (correct),
    // but the UTC header next to it will say 11am (wrong).
    // That happens because of the 2am hour that shouldn't exist in PST.
    // However wrong this looks, Desktop Outlook seems to have the same issue,
    // so I'm choosing to be _consistently_ wrong among both clients. :-)

    const gridLineHeaders = timeZones.map((timeZoneId, index) => (
        <div
            key={'itemsPanelHeaderKey' + index}
            style={headerStyle}
            className={styles.itemsPanelHeader}>
            <GridLineHeaders
                classNames={gridLineHeaderClassNames}
                store={surfaceStore}
                itemsLayout={itemsLayout}
                timeZoneId={index ? timeZoneId : undefined}
                showIsNewDay={!!index}
            />
        </div>
    ));

    return <>{gridLineHeaders.reverse()}</>;
});
